<li
    class="cw-md-stepper__step"
    [ngClass]="{'state--active': active && !disabled}">
    <div class="cw-md-stepper__step__header">
        <h3 class="cw-md-stepper__title"
            tabindex="0"
            (click)="goto()"
            (keydown)="goto()"
        >
            <span class="cw-md-stepper__number" #number></span>
            <span class="cw-md-stepper__title__text">{{title}}</span>
        </h3>
    </div>
    <div class="cw-md-stepper__step__body">
        <ng-content />
    </div>
    <div class="cw-md-stepper__step__footer">
      <div class="flex gap-2">
        <p-button
          [label]="showLoaderOnNext ? '' : nextLabel"
          size="small"
          [disabled]="!allowChangeStep"
          [loading]="showLoaderOnNext"
          (onClick)="continue()"
        />
        @if (!isFirst) {
          <p-button
            label="Back"
            size="small"
            [disabled]="!allowChangeStep"
            (onClick)="back()"
          />
        }
      </div>
    </div>
</li>
